module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Voyage to the Land of Blue Mists")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#world-map"
    }
  }, [_vm._v("World Map")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-1"
    }
  }, [_vm._v("Chapter 1: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("Discovery")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#discovery"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-2"
    }
  }, [_vm._v("Chapter 2: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("The Ship’s Crew")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#the-ships-crew"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-3"
    }
  }, [_vm._v("Chapter 3: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("Commerce")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#commerce"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("The Commission")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-commission",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("Conversion")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#conversion",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("The Race")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-race",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("Confrontation")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#confrontation",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("The Rescue")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-rescue",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "normal"
    }
  }, [_vm._v("Famine")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#famine",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("The Wreck")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-wreck",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Civil War on Land")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#civil-war-on-land",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Civil War at Sea")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#civil-war-at-sea",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("The Traitor Part 1")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#the-traitor-part-1",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("The Traitor Part 2")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-traitor-part-2",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("The Temple")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#the-temple",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("The Land of Blue Mists")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-land-of-blue-mists",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Expulsion")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#expulsion",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("The Search Is Over")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-search-is-over",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("The Return Home")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#the-return-home",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0